import script from "./ReportHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportHeader.vue?vue&type=script&setup=true&lang=js"

import "./ReportHeader.vue?vue&type=style&index=0&id=6efc2bf1&lang=scss&scoped=true"

import exportComponent from "D:\\work\\project\\week-alone\\weekly-alone-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6efc2bf1"]])

export default __exports__